import React, { useState } from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Wand2 } from "lucide-react";
import * as api from "../../lib/api";
import { PrioritySelect } from "./PrioritySelect";
import { AiDescriptionDialog } from "./AiDescriptionDialog";

export function BaseFormFields({
    title,
    setTitle,
    description,
    setDescription,
    priority,
    setPriority,
    titlePlaceholder = "Titre du ticket",
    descriptionPlaceholder = "Décrivez votre demande en détail...",
    onTitleChange,
    allowedPriorities,
    ticketType,
    onTypeChange,
    children,
}) {
    const [aiEnabled, setAiEnabled] = useState(false);
    const [aiOpen, setAiOpen] = useState(false);

    React.useEffect(() => {
        api.getAiStatus().then((d) => setAiEnabled(!!d.enabled)).catch(() => setAiEnabled(false));
    }, []);

    const applyTitle = (value) => {
        setTitle(value);
        if (onTitleChange) onTitleChange(value);
    };

    const handleAiApply = ({ title: aiTitle, type, description: aiDesc }) => {
        if (aiTitle) applyTitle(aiTitle);
        if (type && onTypeChange) onTypeChange(type);
        if (aiDesc) {
            const current = description?.trim();
            setDescription(current ? `${current}\n\n${aiDesc}` : aiDesc);
        }
    };

    return (
        <div className="space-y-6">
            <div className="form-group">
                <Label htmlFor="title" className="form-label">Titre *</Label>
                <Input id="title" value={title} onChange={(e) => applyTitle(e.target.value)} placeholder={titlePlaceholder} required data-testid="ticket-title" />
            </div>

            <PrioritySelect value={priority} onChange={setPriority} allowedPriorities={allowedPriorities} />

            <div className="form-group">
                <div className="flex items-center justify-between mb-1">
                    <Label htmlFor="description" className="form-label mb-0">Description *</Label>
                    {aiEnabled && (
                        <Button type="button" size="sm" variant="outline" onClick={() => setAiOpen(true)}
                            className="gap-1.5 text-purple-600 border-purple-200 hover:bg-purple-50 h-7 text-xs" data-testid="ai-generate-btn">
                            <Wand2 className="w-3 h-3" />Rédiger avec l'IA
                        </Button>
                    )}
                </div>
                <Textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} placeholder={descriptionPlaceholder} rows={5} required data-testid="ticket-description" />
            </div>

            {aiOpen && <AiDescriptionDialog open onClose={() => setAiOpen(false)} ticketType={ticketType} currentTitle={title} onApply={handleAiApply} />}

            {children}
        </div>
    );
}

export function useBaseForm(defaultPriority = "low") {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [priority, setPriority] = useState(defaultPriority);
    return { title, setTitle, description, setDescription, priority, setPriority };
}
